<template>
  <v-container>
    <v-row class="pb-4">
      <v-col>
        <v-icon> mdi-settings </v-icon>
        <span class="headline mx-2">System Access</span>
      </v-col>
    </v-row>
    <v-row
      v-if="loading" 
      class="fill-height"
      
      align="center" 
      justify="center"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </v-row>
    <template v-else>
      <v-row 
        v-if="edit" 
      >
        <v-col cols="6">
          <v-checkbox
            v-model="form.account_locked"
            v-validate="'required'"
            :error-messages="errors.collect('account_locked')"
            data-vv-name="account_locked"     
          >
            <template v-slot:label>
              <div>
                Account Lock
              </div>
            </template>
          </v-checkbox>
        </v-col>
      </v-row>
      <template v-else>
        <v-row>
          <v-col 
            cols="12"
            md="5" 
            xl="4"
          >
            <span class="font-weight-medium">Account Locked:</span>
          </v-col>
          <v-col>
            <v-icon 
              v-if="user.account_locked === 1" 
              color="error"
            >
              mdi-check-outline
            </v-icon>
            <v-icon 
              v-else 
              color="success"
            >
              mdi-close-outline
            </v-icon>        
          </v-col>
        </v-row>
      </template>
    </template>
    <v-card-actions>
      <v-spacer />
      <v-btn
        v-if="!edit"
        color="info"
        @click="editForm"
      >
        Edit
      </v-btn>
      <div v-else>
        <v-btn
          :disabled="progressing"
          text
          @click="edit = false"
        >
          Cancel
        </v-btn>
        <v-btn          
          :loading="progressing"
          color="success"
          @click="submitForm"
        >
          Update
        </v-btn>
      </div>
    </v-card-actions>
  </v-container>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      userUid: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        loading: false,
        progressing: false,
        edit: false,
        user: {},
        form: {
          account_locked: 0,
        },
      }
    },
    watch: {
      userUid: {
        immediate: true,
        handler (value) {
          if (value) {
            this.$resetData()
            this.loadUserSystemAccess()
          }
        },
      },
    },
    methods: {    
      submitForm () {
        this.progressing = true

        this.$api.passwordAttempts().update(this.userUid, this.prepareFormData())
          .then(response => {
            if (response.status >= 200 && response.status < 300) {
              Object.keys(this.form).map(key => {
                this.$set(this.user, key, this.form[key] ? 1 : 0)
              })

              this.edit = false

              this.$snack({
                message: response.data.status,
              })
            }
          })
          .catch(() => {})
          .then(() => {
            this.progressing = false
          })
      },
      loadUserSystemAccess () {
        this.loading = true

        this.$api.passwordAttempts().list(this.userUid)
          .then(response => {            
            this.user = response.data          
          })
          .catch(() => {})
          .then(() => {
            this.loading = false
          })
      },
      editForm () {
        Object.keys(this.form).map(key => {
          this.form[key] = this.user[key] === 1
        })

        this.edit = true
      },
      prepareFormData () {
        return {
          account_locked: this.form.account_locked ? 1 : 0,
        }
      },
    },
  }
</script>
